import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { ExposureSurveyMaterialMostRecent } from '../../entities/EntityModels';
import {UnitOfWork, UserManager} from '../../services/common';
import {HttpClient, HttpHeaders, HTTP_INTERCEPTORS} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';

import { UtilFns } from '../../utils/common';
import { PrintToPdfDocComponent } from '../main/print-to-pdf-doc.component';


@Component({
    selector: 'exposure-survey-last-report',
    templateUrl: './exposure-survey-last-report.html',
})
export class ExposureSurveyLastReportComponent implements OnInit {

    @ViewChild(PrintToPdfDocComponent, { static: true }) _printToPdfDocComponent: PrintToPdfDocComponent;

    @Input() reportItems: ExposureSurveyMaterialMostRecent[];

    _documentManagementUrl: string;
    _isLoading = false;
    _validationMessage: string;

    constructor(private _httpClient: HttpClient, public _uow: UnitOfWork, private _userManager: UserManager) {
    }

    ngOnInit() {
        this._uow.getDocumentManagementUrl().then(url => {
            this._documentManagementUrl = url  + '/Report';
        });
    }

    get utilFns() {
        return UtilFns;
    }

    printExposureSurveyLastReport() {
        const ele = document.querySelector('#report-data');
        UtilFns.printElement(ele);
    }

    // ************************************************************************
    // document management web api url
    // ************************************************************************
    getDownloadFileURL(): Observable<any> {
        let url: string;
        url = this._documentManagementUrl + '/GetExposureSurveyMaterialMostRecentReportFile';

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public exportReportFile() {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL()
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    const file = new Blob([data], { type: 'text/plain;charset=utf-8;' });
                    const fileURL = URL.createObjectURL(file);

                    // window.open(fileURL);
                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = 'ExposureSurveyMostRecent.csv';
                    document.body.appendChild(a);
                    a.click();

                    a.remove();

                    window.URL.revokeObjectURL(fileURL);

                    this._validationMessage = 'File download successful.';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
